module.exports = __webpack_public_path__ + "13e631d25bf5b8fcfbf37f7e2970f62a.png";